import { useState, useEffect } from 'react';
import { defaultRouter } from 'app/common/router';

export const useRouteContext = () => {
  const [routeContext, setRouteContext] = useState(defaultRouter.getRoute());

  useEffect(() => defaultRouter.subscribe(setRouteContext), [setRouteContext]);

  return routeContext;
};
